import ResourcePage from "@/components/ResourcePage";

const STATUS = [
  { value: "open", label: "Offen" },
  { value: "in_progress", label: "In Arbeit" },
  { value: "done", label: "Erledigt" },
  { value: "cancelled", label: "Abgebrochen" },
];

const PRIORITY = [
  { value: "low", label: "Niedrig" },
  { value: "medium", label: "Mittel" },
  { value: "high", label: "Hoch" },
];

export default function TasksPage() {
  return (
    <ResourcePage
      resource="tasks"
      title="Aufgaben"
      subtitle="Was ist zu tun – für dich und für dein Team."
      singular="Aufgabe"
      newButtonLabel="Aufgabe anlegen"
      createDialogTitle="Aufgabe anlegen"
      editDialogTitle="Aufgabe bearbeiten"
      submitButtonLabel="Aufgabe speichern"
      emptyDescription="Lege deine erste Aufgabe an."
      emptyCreateButtonLabel="Aufgabe anlegen"
      testidPrefix="tasks"
      defaultValues={{ status: "open", priority: "medium" }}
      fields={[
        { name: "title", label: "Titel", type: "text", required: true },
        { name: "status", label: "Status", type: "select", options: STATUS },
        { name: "priority", label: "Priorität", type: "select", options: PRIORITY },
        { name: "due_date", label: "Fällig am", type: "datetime" },
        {
          name: "assigned_to",
          label: "Zugewiesen an",
          type: "select",
          optionsFromResource: "users",
        },
        {
          name: "company_id",
          label: "Firma",
          type: "select",
          optionsFromResource: "companies",
        },
        {
          name: "contact_id",
          label: "Person",
          type: "select",
          optionsFromResource: "contacts",
          optionLabel: (c) => `${c.first_name} ${c.last_name}`,
        },
        { name: "description", label: "Beschreibung", type: "textarea", fullWidth: true, rows: 4 },
      ]}
      columns={[
        { key: "title", label: "Titel", render: (r) => <span className="font-medium text-gray-900">{r.title}</span> },
        { key: "priority", label: "Priorität", badge: true },
        { key: "status", label: "Status", badge: true },
        {
          key: "due_date",
          label: "Fällig",
          render: (r) => (r.due_date ? new Date(r.due_date).toLocaleDateString("de-DE") : <span className="text-gray-400">—</span>),
        },
      ]}
    />
  );
}
